(() => {
  const HEADER_LOGO_URL = 'https://fangster.myshopify.com/cdn/shop/files/Fangster-white_1_410x.png?v=1613188422';
  const strings = (window.FANGSTER_I18N && window.FANGSTER_I18N.strings) || {};

  const fixHeaderLogo = () => {
    const link = document.querySelector('.header__heading-link');
    if (!link) return;

    link.classList.add('fg-header-logo-link');
    link.setAttribute('aria-label', `FANGSTER ${strings.home || 'home'}`);

    let image = link.querySelector('.fg-header-logo-img');
    if (!image) {
      link.innerHTML = '';
      image = document.createElement('img');
      image.className = 'fg-header-logo-img';
      image.width = 410;
      image.height = 154;
      image.loading = 'eager';
      image.alt = 'FANGSTER';
      link.appendChild(image);
    }

    if (image.src !== HEADER_LOGO_URL) image.src = HEADER_LOGO_URL;
  };

  const improveAccountLabels = () => {
    document.querySelectorAll('a[href*="/account"]').forEach((link) => {
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', strings.customerAccount || 'Customer account');
    });
  };

  const apply = () => {
    fixHeaderLogo();
    improveAccountLabels();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', apply);

  const observer = new MutationObserver(apply);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
